import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';
import VueCurrencyFilter from 'vue-currency-filter'

import axios from './plugins/axios';

Vue.config.productionTip = false

Vue.http = Vue.prototype.$http = axios

Vue.use(VueCurrencyFilter, {
  // symbol: 'GH₵',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  // symbolSpacing: true
})

Vue.use(VueToast, {
  // One of options
  position: 'top'
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
